import { render, staticRenderFns } from "./DocumentUploads.vue?vue&type=template&id=0574607e&scoped=true&"
import script from "./DocumentUploads.vue?vue&type=script&lang=js&"
export * from "./DocumentUploads.vue?vue&type=script&lang=js&"
import style0 from "./DocumentUploads.vue?vue&type=style&index=0&id=0574607e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0574607e",
  null
  
)

export default component.exports